export const AUTH_FACEBOOK = 'AUTH_FACEBOOK'
export const AUTH_GOOGLE = 'AUTH_GOOGLE'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SIGNUP = 'AUTH_SIGNUP'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_DEGREE = 'AUTH_DEGREE'
export const AUTH_REQUEST_DONE = 'AUTH_REQUEST_DONE'
export const AUTH_JWT_DECODE = 'AUTH_JWT_DECODE'
export const AUTH_STATUS_MSG = 'AUTH_STATUS_MSG'
export const AUTH_MSG_TEXT = 'AUTH_MSG_TEXT'



// WEBPACK FOOTER //
// ./src/store/actions/auth.js